import { render, staticRenderFns } from "./ConfiguracaoApiRow.vue?vue&type=template&id=5a9ff26c"
import script from "./ConfiguracaoApiRow.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoApiRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports